import React from 'react'
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({
    root: { width: '100%',height:'100vh',display:'flex',alignItems:'center',justifyContent:'center',   fontFamily: 'VodafoneRg-Bold',
    fontSize: '1.5rem', },
    instructions: { marginTop: theme.spacing(1), marginBottom: theme.spacing(1) },
    instructions1: { marginTop: theme.spacing(1), marginBottom: theme.spacing(3) },
  }));
const PageLoader = (props) => {
   const classes = useStyles();
    const {children, isLoading,isLoadingContent='' } = props || {}
  return (
    //  isLoading && ( 
        <div className={classes.root}>{isLoadingContent}</div>
    // )
  )
}

export default PageLoader